export function AccountStatusModel() {
    this.needResetPassword = false;
    this.username = null;

    this.setDataFromApi = function (data) {
        this.needResetPassword = data.NewPin;
        this.username = data.UserName;
    };
}

export function ChangePasswordPinModel() {
    this.contactNumber = null;
    this.refcode = null;
    this.password = null;
    this.confirmPassword = null;

    this.setContactNumber = function (contactNumber) {
        this.contactNumber = contactNumber;
    };
    this.setRefcode = function (refcode) {
        this.refcode = refcode;
    };
    this.setPassword = function (password) {
        this.password = password;
    };
    this.setConfirmPassword = function (confirmPassword) {
        this.confirmPassword = confirmPassword;
    };

    this.getParams = function () {
        let params = {
            contact_number: this.contactNumber,
            refcode: this.refcode,
            pin: this.password,
            confirmpin: this.confirmPassword,
        };

        return params;
    };
}
